import { Flex, TooltipText, useTooltip } from '@pancakeswap/uikit'
import BigNumber from 'bignumber.js'
import Apr from 'views/Pools/components/Apr'
import { Text, useMatchBreakpoints } from "@pancakeswap/uikit";
import { BIG_ZERO } from "utils/bigNumber";


interface AprRowProps {
  pool: any
  index?:any
  stakedBalance?: BigNumber
  performanceFee?: number
  showIcon?: boolean
}

const AprRow: React.FC<AprRowProps> = ({ pool,index, stakedBalance, performanceFee = 0, showIcon = true }) => {
// const AprRow: React.FC<AprRowProps> = ({ pool,index, performanceFee = 0, showIcon = true }) => {
//   const { isMobile } = useMatchBreakpoints();
//   const { userData } = pool;
//   const stakedBalance = userData?.stakedBalance
//     ? new BigNumber(userData.stakedBalance)
//     : BIG_ZERO;

  const { vaultKey } = pool

  const tooltipContent = ('APY includes compounding, APR doesn’t. This pool’s CAKE is compounded automatically, so we show APY.')


  const { targetRef, tooltip, tooltipVisible } = useTooltip(tooltipContent, { placement: 'bottom-start' })

  return (
    <Flex alignItems="center" justifyContent="space-between">
      {/* {tooltipVisible && tooltip} */}
      <TooltipText ref={targetRef} color="white" >APR:</TooltipText>
      {/* <Apr pool={pool} index={index} stakedBalance={stakedBalance} showIcon={!isMobile} /> */}
      <Apr pool={pool} index={index} stakedBalance={stakedBalance} performanceFee={performanceFee} showIcon={showIcon} />
    </Flex>
  )
}

export default AprRow
